export const REQUEST_PHYSICAL_DAMAGES =
  "physicalDamage/REQUEST_PHYSICAL_DAMAGES";
export const REQUEST_PHYSICAL_DAMAGES_SUCCESS =
  "physicalDamage/REQUEST_PHYSICAL_DAMAGES_SUCCESS";
export const REQUEST_PHYSICAL_DAMAGES_FAIL =
  "physicalDamage/REQUEST_PHYSICAL_DAMAGES_FAIL";

export const REQUEST_PHYSICAL_DAMAGE = "physicalDamage/REQUEST_PHYSICAL_DAMAGE";
export const REQUEST_PHYSICAL_DAMAGE_SUCCESS =
  "physicalDamage/REQUEST_PHYSICAL_DAMAGE_SUCCESS";
export const REQUEST_PHYSICAL_DAMAGE_FAIL =
  "physicalDamage/REQUEST_PHYSICAL_DAMAGE_FAIL";

export const REQUEST_DEL_PHYSICAL_DAMAGE =
  "physicalDamage/REQUEST_DEL_PHYSICAL_DAMAGE";
export const REQUEST_DEL_PHYSICAL_DAMAGE_SUCCESS =
  "physicalDamage/REQUEST_DEL_PHYSICAL_DAMAGE_SUCCESS";
export const REQUEST_DEL_PHYSICAL_DAMAGE_FAIL =
  "physicalDamage/REQUEST_DEL_PHYSICAL_DAMAGE_FAIL";

// UPLOAD IMAGES
export const REQUEST_UPLOAD_IMG = "physicalDamage/REQUEST_UPLOAD_IMG";
export const REQUEST_UPLOAD_IMG_SUCCESS =
  "physicalDamage/REQUEST_UPLOAD_IMG_SUCCESS";
export const REQUEST_UPLOAD_IMG_FAIL =
  "physicalDamage/REQUEST_UPLOAD_IMG_FAIL";

export const RESET_IMG_UPLOADS = "physicalDamage/RESET_IMG_UPLOADS";
export const UPDATE_IMG_PROGRESS = "physicalDamage/UPDATE_IMG_PROGRESS";

export const REQUEST_UPLOAD_ANNOTATED =
  "physicalDamage/REQUEST_UPLOAD_ANNOTATED";
export const REQUEST_UPLOAD_ANNOTATED_SUCCESS =
  "physicalDamage/REQUEST_UPLOAD_ANNOTATED_SUCCESS";
export const REQUEST_UPLOAD_ANNOTATED_FAIL =
  "physicalDamage/REQUEST_UPLOAD_ANNOTATED_FAIL";

export const REQUEST_DELETE_IMG = "physicalDamage/REQUEST_DELETE_IMG";
export const REQUEST_DELETE_IMG_SUCCESS =
  "physicalDamage/REQUEST_DELETE_IMG_SUCCESS";
export const REQUEST_DELETE_IMG_FAIL =
  "physicalDamage/REQUEST_DELETE_IMG_FAIL";

export const REQUEST_IMG = "physicalDamage/REQUEST_IMG";
export const REQUEST_IMG_SUCCESS = "physicalDamage/REQUEST_IMG_SUCCESS";
export const REQUEST_IMG_FAIL = "physicalDamage/REQUEST_IMG_FAIL";

export const REQUEST_HEADERS = "physicalDamage/REQUEST_HEADERS";
export const REQUEST_HEADERS_SUCCESS =
  "physicalDamage/REQUEST_HEADERS_SUCCESS";
export const REQUEST_HEADERS_FAIL = "physicalDamage/REQUEST_HEADERS_FAIL";

// ESTIMATED COSTS
export const REQUEST_UPLOAD_ESTIMATED_COST =
  "physicalDamage/REQUEST_UPLOAD_ESTIMATED_COST";
export const REQUEST_UPLOAD_ESTIMATED_COST_SUCCESS =
  "physicalDamage/REQUEST_UPLOAD_ESTIMATED_COST_SUCCESS";
export const REQUEST_UPLOAD_ESTIMATED_COST_FAIL =
  "physicalDamage/REQUEST_UPLOAD_ESTIMATED_COST_FAIL";

// DESCRIPTIONS
export const REQUEST_UPLOAD_DESCRIPTION =
  "physicalDamage/REQUEST_UPLOAD_DESCRIPTION";
export const REQUEST_UPLOAD_DESCRIPTION_SUCCESS =
  "physicalDamage/REQUEST_UPLOAD_DESCRIPTION_SUCCESS";
export const REQUEST_UPLOAD_DESCRIPTION_FAIL =
  "physicalDamage/REQUEST_UPLOAD_DESCRIPTION_FAIL";
